import { render, staticRenderFns } from "./MdImage.vue?vue&type=template&id=47385ea0&"
import script from "./MdImage.vue?vue&type=script&lang=js&"
export * from "./MdImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports